import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { onCreateUtmAsync } from './Pension.slice.js'
import { default as Button } from '../../components/Buttons/BaseButton.jsx'
import { Input } from '../../components'
import { Container, Form } from './Pension.styles.js'
import routes from '../../config/settings/routes.js'
import Select, { useSelect } from '../../components/Inputs/Select.jsx'
import getLogger from '../../core/debuggers/logger.js'

const logger = getLogger('AddUtm')

const MONTHS = [
  { value: 0, label: 'January' },
  { value: 1, label: 'February' },
  { value: 2, label: 'March' },
  { value: 3, label: 'April' },
  { value: 4, label: 'May' },
  { value: 5, label: 'June' },
  { value: 6, label: 'July' },
  { value: 7, label: 'August' },
  { value: 8, label: 'September' },
  { value: 9, label: 'October' },
  { value: 10, label: 'November' },
  { value: 11, label: 'December' },
]

const YEARS = Array.from(
  { length: 6 },
  (_, i) => {
    const year = new Date().getFullYear() - 2 + i
    return { value: year, label: year }
  }
)

const AddUtm = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  
  const { error: targetMonthError, value: targetMonthValue, onChange: handleTargetMonthChange } = useSelect({ initialValue: 0 })
  const { error: targetYearError, value: targetYearValue, onChange: handleTargetYearChange } = useSelect({ initialValue: 2026 })

  const [utm, setUtm] = useState({
    value: '',
    source: '',
    targetMonth: '',
    targetYear: ''
  })

  const handleChange = event => {
    const { name, value } = event.target
    setUtm(inputs => ({...inputs, [name]: value}))
  }
  
  const handleSave = event => {
    event.preventDefault()

    const payload = {
      ...utm,
      targetMonth: targetMonthValue,
      targetYear: targetYearValue
    }

    logger.debug('Saving UTM', payload)

    dispatch(onCreateUtmAsync(payload))
    navigate(routes.utm)
  }

  return (
    <Container>
      <Form onSubmit={handleSave}>
        <Input
          label='Value'
          name='value'
          onChange={handleChange}
          placeholder='value'
        />
        <Input
          label='Source'
          name='source'
          onChange={handleChange}
          placeholder='source'
        />
        <Select
          label="Target Month"
          error={targetMonthError}
          options={MONTHS}
          value={targetMonthValue}
          onChange={handleTargetMonthChange}
        />
        <Select
          label="Target Year"
          error={targetYearError}
          options={YEARS}
          value={targetYearValue}
          onChange={handleTargetYearChange}
        />
        <Button
          margin='16px 0'
          type='submit'>
          Save
        </Button>
      </Form>
    </Container>
  )
}

export default AddUtm
